document.addEventListener( 'DOMContentLoaded', function () {
	const list = document.querySelector( '.partners-list' );

	if ( !list ) {
		return;
	}

	const items = list.querySelectorAll( '.partners-list__item' );
	const mobileQuery = window.matchMedia( '(max-width: 991px)' );

	if ( !items.length ) {
		return;
	}

	const closeAll = () => {
		items.forEach( ( item ) => {
			item.classList.remove( 'is-active' );
			item.setAttribute( 'aria-expanded', 'false' );
		} );
	};

	items.forEach( ( item ) => {
		item.setAttribute( 'aria-expanded', 'false' );

		item.addEventListener( 'click', ( event ) => {
			if ( !mobileQuery.matches ) {
				return;
			}

			event.stopPropagation();

			const isActive = item.classList.contains( 'is-active' );

			closeAll();

			if ( !isActive ) {
				item.classList.add( 'is-active' );
				item.setAttribute( 'aria-expanded', 'true' );
			}
		} );

		item.addEventListener( 'keydown', ( event ) => {
			if ( !mobileQuery.matches ) {
				return;
			}

			if ( event.key === 'Enter' || event.key === ' ' ) {
				event.preventDefault();
				item.click();
			}
		} );
	} );

	document.addEventListener( 'click', () => {
		if ( mobileQuery.matches ) {
			closeAll();
		}
	} );

	mobileQuery.addEventListener( 'change', ( event ) => {
		if ( !event.matches ) {
			closeAll();
		}
	} );
} );
